import {Origin} from "../../libs/enum/origin.enum";

export class InfoDto {

  public readonly type: Origin | undefined;
  public readonly name!: string;
  public readonly websiteUrl!: string;
  public readonly loginUrl!: string;
  public readonly dashUrl!: string;
  public readonly ssoUrl!: string;
  public readonly termsUrl!: string;
  public readonly privacyUrl!: string;
  public readonly ironBackupViewerUrl: string | undefined;
  public readonly version!: string;

  constructor(init?: Partial<InfoDto> | undefined) {
    Object.assign(this, init);
  }
}
